import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { Button } from "react-bootstrap";

const PasswordShowHide = ({ handlePasswordShow, passwordShow }) => {
  return (
    <div className="col-md-2 align-self-center ps-0">
      <Button
        variant="primary"
        className="passwordIconHide"
        onClick={handlePasswordShow}
      >
        {passwordShow ? (
          <VisibilityOutlinedIcon />
        ) : (
          <VisibilityOffOutlinedIcon />
        )}
      </Button>
    </div>
  );
};
export default PasswordShowHide;
